import { Input, Select } from "antd";
import { Label } from "reactstrap";
import { PickMonthAndYear } from "../pickMonthYear/PickMonthYear";

const FormInput = ({
  label,
  placeholder,
  value,
  type,
  icon,
  width,
  className,
  handleChange,
  dropdown,
  options,
  style,
  showSearch,
  errorMessage,
  required,
  monthYear,
  readOnly,
  size,
  suffix,
  onFocus,
  onBlur,
  onKeyDown
}) => {
  return (
    <>
      {dropdown ? (
        <>
          <Label className="mb-1 fw-bold">{label}</Label>
          <Select
            className={`mb-3 ${className} drop_down_style w-100 `}
            placeholder={placeholder}
            style={style}
            options={options}
            width={width}
            onChange={handleChange}
            autoComplete="off"
            value={value}
            showSearch={showSearch}
            size={size}
          />
        </>
      ) : monthYear ? (
        <PickMonthAndYear setPickValue={handleChange} />
      ) : (
        <>
          <Label className="mb-1 fw-bold">{label}</Label>
          <Input
            type={type}
            placeholder={placeholder}
            className={`mb-3 ${className}`}
            prefix={icon}
            value={value}
            onChange={handleChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            width={width}
            autoComplete="off"
            required={required}
            readOnly={readOnly}
            size={size}
            style={style}
            suffix={suffix}
          />

          {/* {
            errorMessage && <>
              <div className="text-danger mb-2">
                {errorMessage}
              </div>
            </>
          } */}
        </>
      )}
    </>
  );
};

export default FormInput;
